'use client';

import React, { useMemo } from 'react';
import TitleBar from '../layout/TitleBar';
import { useParams } from 'react-router-dom';
import ReportOutageActionButton from '@/components/outage/ReportOutageActionButton';
import OutageTable from '@/components/outage/OutageTable';
import { useOutages } from '@/hooks/api/useOutages';
import { useAtms } from '@/hooks/api/useAtms';
import ReportRejectActionButton from '@/components/reject/ReportRejectActionButton';
import RejectTable from '@/components/reject/RejectTable';
import { useRejects } from '@/hooks/api/useRejects';

const AtmAssetPage: React.FC = () => {


  const { atmId } = useParams();
  const { data: atmsData } = useAtms();
  const { data: outagesData } = useOutages();
  const { data: rejectsData } = useRejects();
  
  const atms = useMemo(() => {
    if (!atmsData) return [];
    return Array.isArray(atmsData) ? atmsData : Object.values(atmsData);
  }, [atmsData]);
  
  const atmOutages = useMemo(() => {
    if (!outagesData) return [];
    const outages = Array.isArray(outagesData) ? outagesData : Object.values(outagesData);
    return outages.filter((o: any) => o.type === 'atm' && o.assetId === atmId);
  }, [outagesData, atmId]);
  
  const atmRejects = useMemo(() => {
    if (!rejectsData) return [];
    const rejects = Array.isArray(rejectsData) ? rejectsData : Object.values(rejectsData);
    return rejects.filter((r: any) => r.type === 'atm' && r.assetId === atmId);
  }, [rejectsData, atmId]);
  
  const atm = atms.find((x: any) => x.id === parseInt(atmId!));


  const breadcrumbs = [
    { label: 'Home', href: '/app/dashboard' },
    { label: 'ATM', href: '/app/atm/assets' }, // No href for the current page
    { label: atmId ? atmId.toString() : '', href: '#' }
  ];

  const rightContent = (
    <>
      <ReportOutageActionButton type={'atm'} assetId={atmId!} />
      <ReportRejectActionButton type={'atm'} assetId={atmId!} />
    </>
  );

  return (

    <>
      <TitleBar
        breadcrumbs={breadcrumbs}
        title={"ATM: " + atm?.assetId}
        rightContent={rightContent}
      />
      <OutageTable type={'atm'} assetId={Number(atmId!)} outages={atmOutages} />
      <br/>
      <RejectTable type={'atm'} assetId={Number(atmId!)} rejects={atmRejects} />
    </>

  );
};

export default AtmAssetPage;
